<template>
  <MDBContainer>
    <section class="my-5">
      <div id="company_info">
        <div class="text-center">
          <img :src="company.company_logo_image" v-if="company.company_logo_image" alt="企業ロゴ" class="img-fluid">
          <div class="company_name">
            <h3 class="mt-5 fs-4 sub-page-title">
              {{ company.company_name_read }}
              <br>
              <span class="fs-2 fw-bold sub-page-title" >
                <br>
                {{ company.company_name }}
              </span>
          </h3>
          </div>

        </div>

        <!-- <p class="mb-0">ID:{{ company.public_id }}</p> -->
        <MDBTable border>
          <tbody>
          <tr>
            <th class="align-middle">プロフィール</th>
            <td v-html="company.company_profile"></td>
          </tr>
          <tr>
            <th class="align-middle">所在地</th>
            <td><span v-if="company.zip != 'n/a'">〒{{ company.zip }}<br></span>
              {{ company.pref }} {{ company.address1 }} {{ company.address2 }}<br>
              {{ company.address3 }}
            </td>
          </tr>
          <tr>
            <th class="align-middle">電話</th>
            <td><a :href="'tel:' + company.contact_tel" v-if="company.contact_tel">{{ company.contact_tel }}</a></td>
          </tr>
          <tr>
            <th class="align-middle">メール</th>
            <td><a :href="'mailto:' + company.contact_mailaddress" v-if="company.contact_mailaddress">{{ company.contact_mailaddress }}</a></td>
          </tr>
          <tr>
            <th class="align-middle">WEBサイト</th>
            <td><a :href="company.company_url" v-if="company.company_url">{{company.company_url}}</a></td>
          </tr>
          </tbody>
        </MDBTable>
      </div>
    </section>
  </MDBContainer>
  <section id="webinar_list" class="mt-3 py-3 row justify-content-center shadow">
      <!-- <div class="text-center fs-1 col-12">
        <h3 class="text-dark fw-bold">COMPANY WEBINAR</h3>
      </div> -->
      <div id="section-title" class="section-title text-center">
        <h3 class="text-white ps-4">COMPANY WEBINAR</h3>
      </div>
      <!-- <div class="row">
        <div>
          <h2 class="fw-bold text-center text-white">準備中</h2>
        </div>
      </div> -->
      <div class="row justify-content-center p-0 m-0">
        <div v-for="(webinar) in webinar_list" :key="webinar.public_id"  class="webinar-card col-md-3 col-8 px-0" @click="view_webinar(webinar.public_id)">
        <div>
            <span class="time ps-3">  {{ webinar.webinar_start_at.substring(0, 16) }} ~ {{ webinar.webinar_close_at.substring(11, 16) }}</span><br>
            <div class="desctiption text-start w-100" :class="'cat_bg_'+webinar.genre_key">
            <span class="genre" >「{{ webinar.genre_name }}」</span><br>
            </div>          
            <div class="desctiption text-start w-100" >
              <span class="webinar" v-html="'「'+webinar.webinar_title+'」'"></span><br>
            </div>
            <div class="desctiption text-start w-100 ">
              <span class="company">{{ webinar.company_name }}</span>
            </div>
        </div>    
        </div>
      </div>
  </section>
</template>

<script>
import _ from 'lodash';
import {Api, Http} from '@/utiles/ApiConnect';
import {MDBContainer, MDBTable, MDBCol, MDBRow, MDBCard, MDBListGroup, MDBListGroupItem} from 'mdb-vue-ui-kit';
import dayjs from 'dayjs';

export default {
  data: function() {
    return {
      // 出展者一覧
      company: [],

      // Webinar一覧
      webinar_list: [],
    };
  },

  components: {
    MDBContainer,
    MDBTable,
    // MDBCol,
    // MDBRow,
    // MDBCard,
    // MDBListGroup,
    // MDBListGroupItem,
  },

  /***
   * ライフサイクル
   */
  mounted: function() {
    this.getCompanyInfo();
    this.getWebinarList();
  },

  /***
   * メソッド
   */
  methods: {
    // Webinar出展者の取得
    getCompanyInfo: function() {
      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Exhibitor.Info',
          // 引数の指定
          {
            public_id: this.$route.params.id,
          },
      )
          // 実行結果の取得
          .done(function(result) {
            this.company = result.data;
          }.bind(this));
    },

    // Webinar一覧の取得
    getWebinarList: function() {
      // APIへ接続する。
      Api.connect(
          // 実行するメソッド名
          'Webinar.Search',
          // 引数の指定
          {
            exhibitor_id: this.$route.params.id,
          },
      )
          // 実行結果の取得
          .done(function(result) {
            // this.webinar_list = _.sortBy(result.data, ['webinar_start_at']);
            this.webinar_list = (_.sortBy(result.data, ['webinar_start_at'])).filter((webinar)=>{return webinar.company_name==this.company.company_name});
          }.bind(this));
    },

    // Webinar詳細画面へ
    view_webinar(webinar_id) {
      this.$router.push('/webinar/' + webinar_id);
    },

    // 時間を30っ分たす
    add30minute: function (time) {
      let temp = this.HourStrToMinute(time);
      temp = temp + 30;
      temp = this.MinuteToHourStr(temp);
      return temp;
    },

    // 時間のテックスを分に変える
    HourStrToMinute: function (Time) {
        return (parseInt(Time.hh)*60) + 
        parseInt(Time.mm);
    },

    // 分を時間のテックスに変える
    MinuteToHourStr: function (minute){
        let time ={
        hh:Math.floor(minute / 60),
        mm:minute % 60
        }
        return this.getTimeText(time);
    },

    // 時間のテックスを習得
    getTimeText: function (temp) {
        let tempM;
        let tempH;
        if (temp.mm < 10) {
        tempM = `0${temp.mm}`;
        } else {
        tempM = `${temp.mm}`;
        }
        if (temp.hh < 10) {
        tempH = `0${temp.hh}`;
        } else {
        tempH = `${temp.hh}`;
        }
        return `${tempH}:${tempM}`;
    },

    // Webinar終了時間の取得
    getWebinarEndTime: function (strtime){
      let time = {hh:strtime.substring(0, 2),mm:strtime.substring(3)};
      let inMinute = this.HourStrToMinute(time);
      inMinute = inMinute + 25;
      return this.MinuteToHourStr(inMinute);
    },

    show_webinar: function(webinar_id) {
      this.$router.push('/webinar/' + webinar_id);
    },
  },
};
</script>

<style scoped lang="scss">
@import "../../node_modules/mdb-vue-ui-kit/src/scss/index.free";

#app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
}
.container{
  min-height: 80vh;
}
#company_info {
  img {
    max-width: 60%;
    max-height: 350px;
  }
  .company_name h3{
    color:var(--primary);
    span{
      color:var(--primary);
    }
  }
}

.section-title{

    background-image: url(@/assets/タイトルバー.png);
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
    text-align: center;
    margin: auto;
    width: 650px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;

      @include media-breakpoint-down(md) {
        width: auto;
        height: 150px;
      }
      
      @include media-breakpoint-down(sm) {
        width: 350px;
        height: 50px;
      }

      h3{
        color: #13115E;
        font-size: 3.2rem;
        @include media-breakpoint-down(md) {
          font-size: 1.6rem !important;
          // padding: 0 !important;
        }
      }
  }
#webinar_list {
  // background: var(--primary-02);
  background-image:url("@/assets/WebinarWeekのポイント.jpg");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center center;
  h3{
    color:var(--primary);
    letter-spacing: 1px;
    font-family: "meiryo" !important;
  }
  .webinar-card{
    min-height: 225px;
    height: initial !important;
    // container 
    border-radius: 1rem;
    margin: 1rem;
    // accesoris
    background-color:white;
    // box-shadow: 0rem 0.25rem 0.5rem rgba(0,0,0,0.1);
    border:solid 0.5px var(--primary-05);
    box-shadow: 0rem 0.25rem 0.5rem var(--primary-03);
    // animation
    cursor: pointer;
    transition:all ease 0.3s;
    .desctiption{
      .webinar{
      // font
      font-weight: bold;
      }
      padding: 0.2rem 1rem 0.2rem 1rem;
    }
  } 
}
</style>